// extracted by mini-css-extract-plugin
module.exports = {"wrap":"AlgorithmCheckbox_wrap__37OMY","visibility":"AlgorithmCheckbox_visibility__U1XTz"};